/* Balayage des photos sur les vignettes produit (mobile) : mise a jour des points */
(function () {
  if (window.__plSwipeReady) return;
  window.__plSwipeReady = true;

  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track || !track.classList || !track.classList.contains('pl-swipe')) return;
    if (track.__plSwipeFrame) return;

    track.__plSwipeFrame = window.requestAnimationFrame(function () {
      track.__plSwipeFrame = null;
      var width = track.clientWidth;
      var wrapper = track.parentNode;
      if (!width || !wrapper) return;

      var index = Math.round(track.scrollLeft / width);
      var dots = wrapper.querySelectorAll('.pl-swipe__dot');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    });
  }, true);
})();
